import { SOURCE_CHAIN } from "@/mocks/content";

export default function SourceChain() {
  return (
    <section id="source" className="relative w-full overflow-hidden bg-foreground-950 py-16 md:py-20">
      <div className="pointer-events-none absolute inset-0 opacity-[0.05]">
        <div className="absolute -top-20 -right-20 h-80 w-80 rounded-full bg-primary-500 blur-3xl"></div>
        <div className="absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-accent-500 blur-3xl"></div>
      </div>

      <div className="relative mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-12 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-sm font-bold tracking-[0.25em] text-accent-400">SOURCE CHAIN · 编辑部解密</p>
            <h2 className="font-heading text-2xl font-black text-foreground-50 md:text-4xl">
              一条爆料，是怎么走完整个链条的
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
              从知情人士的只言片语，到见诸公开报道——中间隔着蹲点、核实与取舍。我们把这条「从耳闻到确信」的路走给你看。
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute top-8 right-0 left-6 hidden h-px bg-gradient-to-r from-primary-500 via-accent-500/60 to-foreground-700 lg:left-32 lg:block"></div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {SOURCE_CHAIN.map((s) => (
              <div
                key={s.step}
                className="group relative rounded-lg border border-foreground-800 bg-foreground-900/60 p-6 backdrop-blur transition-colors hover:border-primary-500/70"
              >
                <div className="mb-5 flex items-center gap-3">
                  <span className={`flex h-16 w-16 items-center justify-center rounded-lg font-heading text-2xl font-black text-foreground-950 ${s.color}`}>
                    {s.step}
                  </span>
                  <div>
                    <p className="text-xs font-semibold tracking-widest text-foreground-500">阶段 · {s.step}</p>
                    <h3 className="font-heading text-base font-black text-foreground-50">{s.role}</h3>
                  </div>
                </div>
                <p className="text-sm font-semibold text-accent-300">{s.title}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-300">{s.desc}</p>
                <div className="mt-5 flex items-center gap-2 border-t border-foreground-800 pt-4">
                  <span className="flex h-2 w-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs text-foreground-500">编辑部信源分级标注</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-lg border border-foreground-800 bg-foreground-900/50 p-6 md:flex-row md:items-center">
          <p className="max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
            想看证据链怎么被逐条核对？我们整理了内部核实流程与匿名投稿的加密链路，全部公开在「关于我们」。
          </p>
          <a
            href="#about"
            className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
          >
            了解核实流程 <i className="ri-arrow-right-line ml-1.5"></i>
          </a>
        </div>
      </div>
    </section>
  );
}